import { IconComponent } from "../icon.types";

export const FileInputIcon: IconComponent = (props) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_914_1844)">
      <path
        d="M9.00006 22.6605C6.21434 21.0522 5.25658 17.4777 6.86491 14.692L11.8649 6.03178C13.0149 4.03992 15.5648 3.35667 17.5567 4.50667C19.5485 5.65667 20.2318 8.20659 19.0818 10.1984L14.0818 18.8587C13.3943 20.0495 11.8575 20.4613 10.6667 19.7738C9.47594 19.0863 9.06416 17.5495 9.75166 16.3587L14.335 8.42013L15.7784 9.25347L11.195 17.192C10.9659 17.589 11.1031 18.1012 11.5001 18.3304C11.897 18.5596 12.4092 18.4223 12.6384 18.0254L17.6384 9.36511C18.3259 8.17433 17.9141 6.63755 16.7233 5.95005C15.5326 5.26255 13.9958 5.67433 13.3083 6.86511L8.30828 15.5254C7.15828 17.5172 7.84153 20.0671 9.83339 21.2171C11.8253 22.3671 14.3752 21.6839 15.5252 19.692L21.3585 9.5884L22.8019 10.4217L16.9685 20.5254C15.3602 23.3111 11.7858 24.2688 9.00006 22.6605Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_914_1844">
        <rect
          width="20"
          height="20"
          fill="currentColor"
          transform="translate(10.3398 0.339844) rotate(30)"
        />
      </clipPath>
    </defs>
  </svg>
);
